import React from 'react'
import classnames from 'classnames'
import { IconButton } from 'shared/ui/IconButton/ui/IconButton'
import type { ITooltipProps } from 'shared/ui/Tooltip'
import type { ZIndex } from 'shared/constants/zIndex'
import styles from '../styles.module.scss'

type IIconUrlButtonProps = {
  value: string | number | undefined
  tooltipLabel?: string
  showTooltip?: boolean
  show?: boolean
  onClose?: () => void
  onOpen?: () => void
  zIndex?: ZIndex
}

export const IconUrlButton: React.FC<IIconUrlButtonProps> = ({
  value,
  tooltipLabel,
  showTooltip = false,
  show = true,
  onOpen,
  onClose,
  zIndex,
}) => {
  const handleClose = () => {
    onClose && onClose()
  }

  const handleOpen = () => {
    onOpen && onOpen()
  }

  const tooltipProps: ITooltipProps = {
    label: tooltipLabel ?? value,
    placement: 'top',
    disableInteractive: true,
    onClose: handleClose,
    onOpen: handleOpen,
    zIndex,
  }

  const onOpenUrl = async () => {
    const url = new URL(`${value}`)
    window.open(url, '_blank')
  }

  return (
    <div
      className={classnames(styles.rightIcon, {
        [styles.hidden]: !show,
      })}
    >
      <IconButton
        icon={'linkExternalLine'}
        variant={'icon'}
        color={'secondary'}
        size={'small'}
        fontSize={16}
        onClick={onOpenUrl}
        tooltipProps={showTooltip ? tooltipProps : undefined}
        ariaLabel='IconUrlButton'
      />
    </div>
  )
}
